(() => {
  const normalise = (value) => String(value || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLocaleLowerCase();

  const firstMeaningfulChild = (element) => {
    if (!element) return null;
    return Array.from(element.children).find((child) => {
      if (child.hidden) return false;
      if (child.matches('script, style')) return false;
      return normalise(child.textContent) !== '' || child.children.length > 0;
    }) || null;
  };

  const markDuplicate = (element) => {
    if (!element) return;
    element.classList.add('fg-duplicate-page-heading');
    element.setAttribute('aria-hidden', 'true');
  };

  const removeLeadingContentHeading = (container, title) => {
    if (!container || !title) return;

    let scope = container;
    let depth = 0;
    let removed = 0;

    while (scope && depth < 4 && removed < 2) {
      const first = firstMeaningfulChild(scope);
      if (!first) return;

      if (/^H[1-3]$/.test(first.tagName)) {
        if (normalise(first.textContent) === title) {
          first.remove();
          removed += 1;
          continue;
        }
        return;
      }

      if (/^(DIV|SECTION|ARTICLE|MAIN)$/.test(first.tagName)) {
        scope = first;
        depth += 1;
        continue;
      }

      return;
    }
  };

  const clean = (scope = document) => {
    const heroHeading = scope.querySelector('.fg-page-hero h1') || document.querySelector('.fg-page-hero h1');
    if (!heroHeading) return;

    const title = normalise(heroHeading.textContent);
    if (!title) return;

    document.querySelectorAll('.main-page-title, .shopify-policy__title h1').forEach((heading) => {
      if (normalise(heading.textContent) === title) markDuplicate(heading);
    });

    document.querySelectorAll('.rte, .shopify-policy__body').forEach((content) => {
      removeLeadingContentHeading(content, title);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => clean());
  } else {
    clean();
  }

  document.addEventListener('shopify:section:load', (event) => clean(event.target));

  const observer = new MutationObserver(() => clean());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
